"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  OptimizationGraphLine: ['optimization-graph-line', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.124,9.95,21.39,9.733a.25.25,0,0,1-.21-.184,9.4,9.4,0,0,0-.959-2.3.251.251,0,0,1,.019-.279l1.075-1.383a1,1,0,0,0-.082-1.321l-1.5-1.5a1,1,0,0,0-1.321-.082L17.033,3.76a.25.25,0,0,1-.279.019,9.392,9.392,0,0,0-2.3-.958.25.25,0,0,1-.184-.211L14.051.876A1,1,0,0,0,13.059,0H10.941a1,1,0,0,0-.992.876L9.732,2.61a.25.25,0,0,1-.184.211,9.392,9.392,0,0,0-2.3.958.25.25,0,0,1-.279-.019L5.584,2.684a1,1,0,0,0-1.32.083l-1.5,1.5a1,1,0,0,0-.082,1.322L3.76,6.968a.251.251,0,0,1,.019.279,9.4,9.4,0,0,0-.959,2.3.25.25,0,0,1-.21.184L.877,9.95A1,1,0,0,0,0,10.942v2.117a1,1,0,0,0,.876.992l1.734.217a.248.248,0,0,1,.21.183,9.4,9.4,0,0,0,.959,2.3.251.251,0,0,1-.019.279L2.685,18.416a1,1,0,0,0,.082,1.321l1.5,1.5a1,1,0,0,0,1.321.082h0l1.383-1.075a.25.25,0,0,1,.279-.019,9.415,9.415,0,0,0,2.3.958.249.249,0,0,1,.184.21l.217,1.735a1,1,0,0,0,.992.875h2.118a1,1,0,0,0,.992-.875l.217-1.735a.249.249,0,0,1,.184-.21,9.415,9.415,0,0,0,2.3-.958.25.25,0,0,1,.279.019l1.383,1.076a1,1,0,0,0,1.32-.083l1.5-1.5a1,1,0,0,0,.082-1.322L20.24,17.033a.251.251,0,0,1-.019-.279,9.4,9.4,0,0,0,.959-2.3.248.248,0,0,1,.21-.183l1.734-.217A1,1,0,0,0,24,13.059V10.942A1,1,0,0,0,23.124,9.95ZM12,18.973a7,7,0,1,1,7-7A7,7,0,0,1,12,18.973Z', 'M15.852,9.768,13.787,11.6a.249.249,0,0,1-.314.013L12.106,10.6a1.873,1.873,0,0,0-1.134-.339,1.767,1.767,0,0,0-1.119.431L7.336,12.928a1,1,0,1,0,1.328,1.495L10.9,12.441a.25.25,0,0,1,.315-.013l1.366,1.011a1.868,1.868,0,0,0,1.135.34,1.769,1.769,0,0,0,1.119-.431l2.349-2.084a1,1,0,1,0-1.328-1.5Z']],
  OptimizationClock: ['optimization-clock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.25,24a6.5,6.5,0,1,0-6.5-6.5A6.508,6.508,0,0,0,15.25,24ZM14.5,13.5a.75.75,0,0,1,1.5,0v3a.25.25,0,0,0,.25.25h2a.75.75,0,0,1,0,1.5h-3a.75.75,0,0,1-.75-.75Z', 'M11.457,9.293a1,1,0,0,0-1.414,0l-2.5,2.5a1,1,0,0,0,1.414,1.415l2.5-2.5A1,1,0,0,0,11.457,9.293Z', 'M20.457,9.293a1,1,0,1,0-1.414,1.415l2.5,2.5a1,1,0,0,0,1.414-1.415Z', 'M19.75,0h-16a3,3,0,0,0-3,3V14.5a3,3,0,0,0,3,3h2.5a1,1,0,0,0,0-2H3.75a1,1,0,0,1-1-1V5.25A.25.25,0,0,1,3,5H20.5a.25.25,0,0,1,.25.25V8a1,1,0,0,0,2,0V3A3,3,0,0,0,19.75,0ZM4.5,3.5a.75.75,0,1,1,.75-.75A.749.749,0,0,1,4.5,3.5ZM7,3.5a.75.75,0,1,1,.75-.75A.749.749,0,0,1,7,3.5Zm2.5,0a.75.75,0,1,1,.75-.75A.749.749,0,0,1,9.5,3.5Z']],
  OptimizationRocketGraph: ['optimization-rocket-graph', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.366.345a.75.75,0,1,0-1.06,1.061.25.25,0,0,1,0,.353L20.2,2.865a.254.254,0,0,1-.221.07,1.44,1.44,0,0,0-.264-.024h0a1.488,1.488,0,0,0-1.06.44l-1.711,1.71a.251.251,0,0,1-.26.059,1.5,1.5,0,0,0-1.565.352L14.073,6.517A.247.247,0,0,0,14,6.693V13.08a.241.241,0,0,0,.411.17h0l.637-.638a.251.251,0,0,1,.211-.07.247.247,0,0,1,.184.125,4.527,4.527,0,0,1-.739,5.391,4.5,4.5,0,0,1-6.364,0A.09.09,0,0,1,8.4,17.9h.4a.75.75,0,0,0,.281-1.445H3.419A.75.75,0,0,0,3.7,17.9h.8a.25.25,0,0,1,.227.144,7.441,7.441,0,0,0,1.5,2.131A7.518,7.518,0,0,0,7.83,21.408a.25.25,0,0,1-.123.467H6.25a1,1,0,0,0,0,2h11a1,1,0,0,0,0-2H15.337a.25.25,0,0,1-.123-.467,7.515,7.515,0,0,0,2.336-11,.251.251,0,0,1,.024-.326l1.079-1.079a1.5,1.5,0,0,0,.352-1.564.252.252,0,0,1,.059-.261l1.711-1.71a1.489,1.489,0,0,0,.44-1.061,1.451,1.451,0,0,0-.024-.265.251.251,0,0,1,.07-.221l1.105-1.1a.251.251,0,0,1,.354,0,.75.75,0,1,0,1.06-1.061Z', 'M0,12.459a1,1,0,0,0,1,1H12a1,1,0,0,0,0-2H1A1,1,0,0,0,0,12.459Z', 'M-0.000 6.959 L3.000 6.959 L3.000 10.459 L-0.000 10.459 Z', 'M4.500 4.459 L7.500 4.459 L7.500 10.459 L4.500 10.459 Z', 'M9.000 1.459 L12.000 1.459 L12.000 10.359 L9.000 10.359 Z']],
  OptimizationRocketGrowth: ['optimization-rocket-growth', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.266,2.9a.251.251,0,0,1,.354,0,.75.75,0,0,0,1.06-1.061L22.266.428a.75.75,0,1,0-1.06,1.061.25.25,0,0,1,0,.353L20.1,2.949a.251.251,0,0,1-.221.07,1.5,1.5,0,0,0-1.324.415L16.845,5.143a.252.252,0,0,1-.261.059,1.5,1.5,0,0,0-.5-.087h0a1.486,1.486,0,0,0-1.06.44L10.776,9.8a1.5,1.5,0,0,0,0,2.121l1.414,1.415a1.5,1.5,0,0,0,2.121,0l.637-.637a.25.25,0,0,1,.395.054,4.526,4.526,0,0,1-.739,5.391,4.5,4.5,0,0,1-6.363,0,.09.09,0,0,1,.064-.154h.4a.75.75,0,0,0,0-1.5H3.6a.75.75,0,0,0,0,1.5h.8a.25.25,0,0,1,.227.144,7.527,7.527,0,0,0,3.112,3.36.25.25,0,0,1-.123.467H6.15a1,1,0,1,0,0,2h11a1,1,0,0,0,0-2H15.232a.25.25,0,0,1-.123-.467,7.5,7.5,0,0,0,2.342-11,.25.25,0,0,1,.024-.326L18.554,9.09a1.5,1.5,0,0,0,.352-1.564.25.25,0,0,1,.059-.26l1.71-1.711a1.493,1.493,0,0,0,.44-1.061,1.459,1.459,0,0,0-.024-.265.249.249,0,0,1,.07-.22Z', 'M.393,8.249a1,1,0,0,0,1.414,0L4.966,5.09a.251.251,0,0,1,.354,0L6.479,6.25a2,2,0,0,0,2.828,0l2.47-2.47a.25.25,0,0,1,.353,0L13.247,4.9a.5.5,0,0,0,.353.146A.494.494,0,0,0,13.792,5a.5.5,0,0,0,.308-.462v-4a.5.5,0,0,0-.5-.5h-4A.5.5,0,0,0,9.247.9l1.116,1.116a.25.25,0,0,1,0,.353L8.07,4.658a.25.25,0,0,1-.354,0L6.557,3.5a2,2,0,0,0-2.828,0L.393,6.835A1,1,0,0,0,.393,8.249Z']],
  OptimizationTimer: ['optimization-timer', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.3,11.12a6.5,6.5,0,1,0,2.408,0,.25.25,0,0,1-.2-.245V10.25a.25.25,0,0,1,.25-.25H19a1,1,0,0,0,0-2H14a1,1,0,0,0,0,2h1.25a.25.25,0,0,1,.25.25v.625A.249.249,0,0,1,15.3,11.12ZM15.75,14a.75.75,0,0,1,1.5,0v2.5a.25.25,0,0,0,.25.25h1a.75.75,0,0,1,0,1.5h-2a.75.75,0,0,1-.75-.75Z', 'M23,3a3,3,0,0,0-3-3H4A3,3,0,0,0,1,3V14.5a3,3,0,0,0,3,3H8a1,1,0,0,0,0-2H4a1,1,0,0,1-1-1V5.25A.25.25,0,0,1,3.25,5h17.5a.25.25,0,0,1,.25.25V11a1,1,0,0,0,2,0ZM4.75,3.5a.75.75,0,1,1,.75-.75A.749.749,0,0,1,4.75,3.5Zm2.5,0A.75.75,0,1,1,8,2.75.749.749,0,0,1,7.25,3.5Zm2.5,0a.75.75,0,1,1,.75-.75A.749.749,0,0,1,9.75,3.5Z']],
  OptimizationPlane: ['optimization-plane', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.873,19.339l-1.705-4.267a.25.25,0,0,0-.232-.157H2.064a.25.25,0,0,0-.232.157l-1.7,4.266a1.777,1.777,0,0,0,.111,1.548,1.516,1.516,0,0,0,1.311.779h20.9a1.517,1.517,0,0,0,1.311-.778A1.777,1.777,0,0,0,23.873,19.339ZM6.5,18.415H5a.75.75,0,0,1,0-1.5H6.5a.75.75,0,0,1,0,1.5Z', 'M2.631,13.072a.254.254,0,0,0,.025.233.251.251,0,0,0,.207.11H21.137a.25.25,0,0,0,.232-.343l-.759-1.9a1.547,1.547,0,0,0-1.423-1.008H11.036a.247.247,0,0,0-.132.038L8.125,11.928A1.559,1.559,0,0,1,6.4,11.88L4.336,10.431a.252.252,0,0,0-.246-.023,2.16,2.16,0,0,0-.21.105.5.5,0,0,0-.094.071,1.666,1.666,0,0,0-.395.588Z', 'M6.853,8.253a.25.25,0,0,1-.277.014l-1.594-.95a.254.254,0,0,0-.107-.034H4.849a.31.31,0,0,0-.2.07l-1.031.864a.29.29,0,0,0-.053.052.31.31,0,0,0,.047.437l3.358,2.357a.567.567,0,0,0,.325.1.558.558,0,0,0,.3-.085l9.162-5.688A1.594,1.594,0,0,0,17.5,4.013a1.522,1.522,0,0,0-.09-.513,1.61,1.61,0,0,0-1.155-1.037,1.511,1.511,0,0,0-1.187.228l-2.6,1.774a.252.252,0,0,1-.229.028L6.512,2.36a.391.391,0,0,0-.134-.024.385.385,0,0,0-.23.076L5.11,3.181a.378.378,0,0,0-.062.058.385.385,0,0,0,.044.544L9.024,6.217a.252.252,0,0,1,.118.2.249.249,0,0,1-.1.211Z']],
  OptimizationTimer1: ['optimization-timer-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,0H3A3,3,0,0,0,0,3V18a3,3,0,0,0,3,3,1,1,0,0,0,0-2,1,1,0,0,1-1-1V7.5A.5.5,0,0,1,2.5,7h19a.5.5,0,0,1,.5.5V18a1,1,0,0,1-1,1,1,1,0,0,0,0,2,3,3,0,0,0,3-3V3A3,3,0,0,0,21,0ZM4,4.5a1,1,0,1,1,1-1A1,1,0,0,1,4,4.5Zm3,0a1,1,0,1,1,1-1A1,1,0,0,1,7,4.5Zm3,0a1,1,0,1,1,1-1A1,1,0,0,1,10,4.5Z', 'M5.5,17.5a6.5,6.5,0,1,0,11.513-4.133.249.249,0,0,1,.016-.335l.5-.5a.75.75,0,0,0-1.06-1.061l-.576.576a.25.25,0,0,1-.315.031,6.465,6.465,0,0,0-2.616-1.005.25.25,0,0,1-.213-.247V10.5a.25.25,0,0,1,.25-.25h.5a.75.75,0,0,0,0-1.5h-3a.75.75,0,0,0,0,1.5H11a.25.25,0,0,1,.25.25v.325a.25.25,0,0,1-.213.247,6.451,6.451,0,0,0-2.616,1.005.25.25,0,0,1-.315-.031L7.53,11.47a.75.75,0,1,0-1.06,1.061l.5.5a.249.249,0,0,1,.016.335A6.475,6.475,0,0,0,5.5,17.5ZM12,13a4.5,4.5,0,1,1-4.5,4.5A4.505,4.505,0,0,1,12,13Z', 'M12,18.25a.747.747,0,0,0,.53-.219l1.5-1.5a.75.75,0,1,0-1.06-1.061l-1.5,1.5A.75.75,0,0,0,12,18.25Z']],
  OptimizationGraph: ['optimization-graph', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,10.942a1,1,0,0,0-.876-.992L21.39,9.733a.25.25,0,0,1-.21-.184,9.4,9.4,0,0,0-.959-2.3.251.251,0,0,1,.019-.279l1.075-1.383a1,1,0,0,0-.082-1.321l-1.5-1.5a1,1,0,0,0-1.321-.082L17.033,3.76a.25.25,0,0,1-.279.019,9.392,9.392,0,0,0-2.3-.958.25.25,0,0,1-.184-.211L14.051.876A1,1,0,0,0,13.059,0H10.941a1,1,0,0,0-.992.876L9.732,2.61a.25.25,0,0,1-.184.211,9.392,9.392,0,0,0-2.3.958.25.25,0,0,1-.279-.019L5.584,2.684a1,1,0,0,0-1.32.083l-1.5,1.5a1,1,0,0,0-.082,1.322L3.76,6.968a.251.251,0,0,1,.019.279,9.4,9.4,0,0,0-.959,2.3.25.25,0,0,1-.21.184L.877,9.95A1,1,0,0,0,0,10.942v2.117a1,1,0,0,0,.876.992l1.734.217a.248.248,0,0,1,.21.183,9.4,9.4,0,0,0,.959,2.3.251.251,0,0,1-.019.279L2.685,18.416a1,1,0,0,0,.082,1.321l1.5,1.5a1,1,0,0,0,1.321.082h0l1.383-1.075a.25.25,0,0,1,.279-.019,9.415,9.415,0,0,0,2.3.958.249.249,0,0,1,.184.21l.217,1.735a1,1,0,0,0,.992.875h2.118a1,1,0,0,0,.992-.875l.217-1.735a.249.249,0,0,1,.184-.21,9.415,9.415,0,0,0,2.3-.958.25.25,0,0,1,.279.019l1.383,1.076a1,1,0,0,0,1.32-.083l1.5-1.5a1,1,0,0,0,.082-1.322L20.24,17.033a.251.251,0,0,1-.019-.279,9.4,9.4,0,0,0,.959-2.3.248.248,0,0,1,.21-.183l1.734-.217A1,1,0,0,0,24,13.059ZM12,18.973a7,7,0,1,1,7-7A7,7,0,0,1,12,18.973Z', 'M13,13h1.5a.464.464,0,0,0,.5-.416V8.417A.464.464,0,0,0,14.5,8H13a.464.464,0,0,0-.5.417v4.167A.464.464,0,0,0,13,13Z', 'M8.500 10.000 L11.000 10.000 L11.000 13.000 L8.500 13.000 Z', 'M15,14H8.5a1,1,0,0,0,0,2H15a1,1,0,0,0,0-2Z']]
};
exports["default"] = _default;